import {
  HomeSlideRepository,
  CreateHomeSlideInput,
  UpdateHomeSlideInput,
} from '../../domain/repositories/home-slide.repository';
import { HomeSlideEntity } from '../../domain/entities/home-slide.entity';

export interface SaveHomeSlideInput {
  id?: string;
  title: string;
  description?: string;
  buttonTextPrimary?: string;
  buttonTextSecondary?: string;
  buttonUrlPrimary?: string;
  buttonUrlSecondary?: string;
  imageId?: string;
  imageUrl?: string;
  displayOrder?: number;
  isActive?: boolean;
}

export class SaveHomeSlideUseCase {
  constructor(private readonly homeSlideRepository: HomeSlideRepository) {}

  public async execute(input: SaveHomeSlideInput): Promise<HomeSlideEntity> {
    if (input.id && !input.id.startsWith('temp-') && !input.id.startsWith('banner-')) {
      const updateData: UpdateHomeSlideInput = {
        title: input.title,
        description: input.description,
        buttonTextPrimary: input.buttonTextPrimary,
        buttonTextSecondary: input.buttonTextSecondary,
        buttonUrlPrimary: input.buttonUrlPrimary,
        buttonUrlSecondary: input.buttonUrlSecondary,
        imageId: input.imageId,
        imageUrl: input.imageUrl,
        displayOrder: input.displayOrder,
        isActive: input.isActive,
      };
      return this.homeSlideRepository.updateSlide(input.id, updateData);
    }

    const createData: CreateHomeSlideInput = {
      title: input.title,
      description: input.description,
      buttonTextPrimary: input.buttonTextPrimary,
      buttonTextSecondary: input.buttonTextSecondary,
      buttonUrlPrimary: input.buttonUrlPrimary,
      buttonUrlSecondary: input.buttonUrlSecondary,
      imageId: input.imageId,
      imageUrl: input.imageUrl,
      displayOrder: input.displayOrder,
      isActive: input.isActive ?? true,
    };
    return this.homeSlideRepository.createSlide(createData);
  }
}
